const state = () => ({selectedGroup: {}})

// getters
  const getters = {
        getCurrentGroup: (state, getters) => {
          return state.selectedGroup
        }       
    }    
// actions
const actions = {
    setCurrentGroup({ commit }) {       
        state.selectedGroup = {};       
    }
}
// mutations
const mutations = {   
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
